/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_No_MessageInputs */

const en_snapshot_history_no_message = /** @type {(inputs: Snapshot_History_No_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Message`)
};

const fr_snapshot_history_no_message = /** @type {(inputs: Snapshot_History_No_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun message`)
};

const de_snapshot_history_no_message = /** @type {(inputs: Snapshot_History_No_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Nachricht`)
};

const it_snapshot_history_no_message = /** @type {(inputs: Snapshot_History_No_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun messaggio`)
};

const ru_snapshot_history_no_message = /** @type {(inputs: Snapshot_History_No_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет сообщения`)
};

const es_snapshot_history_no_message = /** @type {(inputs: Snapshot_History_No_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin mensaje`)
};

const zh_cn2_snapshot_history_no_message = /** @type {(inputs: Snapshot_History_No_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无消息`)
};

const ja_snapshot_history_no_message = /** @type {(inputs: Snapshot_History_No_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージなし`)
};

const hi_snapshot_history_no_message = /** @type {(inputs: Snapshot_History_No_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई संदेश नहीं`)
};

const pt_pt2_snapshot_history_no_message = /** @type {(inputs: Snapshot_History_No_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma mensagem`)
};

/**
* | output |
* | --- |
* | "No Message" |
*
* @param {Snapshot_History_No_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_no_message = /** @type {((inputs?: Snapshot_History_No_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_No_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_no_message(inputs)
	if (locale === "de") return de_snapshot_history_no_message(inputs)
	if (locale === "it") return it_snapshot_history_no_message(inputs)
	if (locale === "ru") return ru_snapshot_history_no_message(inputs)
	if (locale === "es") return es_snapshot_history_no_message(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_no_message(inputs)
	if (locale === "ja") return ja_snapshot_history_no_message(inputs)
	if (locale === "hi") return hi_snapshot_history_no_message(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_no_message(inputs)
	return en_snapshot_history_no_message(inputs)
});